export enum ServiceName {
    /**
     * supportChat service
     */
    supportChat = 'supportChat',

    /**
     * eventsManagement service
     */
    eventsManagement = 'eventsManagement',

    /**
     * meetings service
     */
    meetings = 'meetings',

    /**
     * catalog service
     */
    catalog = 'catalog',

    /**
     * tabs service
     */
    tabs = 'tabs',

    /**
     * googleAnalytics service
     */
    googleAnalytics = 'googleAnalytics',

    /**
     * webClientFooter service
     */
    webClientFooter = 'webClientFooter',

    /**
     * webClientPageParams service
     */
    webClientPageParams = 'webClientPageParams',

    /**
     * userProfile service
     */
    userProfile = 'userProfile',

    /**
     * ticketSystem service
     */
    ticketSystem = 'ticketSystem',


    /**
     * chat service
     */
    messenger = 'messenger',

    /**
     * favorite sessions service
     */
    favoriteSessions = 'favoriteSessions',

    /**
     * notifications service
     */
    notifications = 'notifications',

    /**
     * ratings service
     */
    ratings = 'ratings',

    /**
     * using app anonymously
     */
    anonymousUsing = 'anonymousUsing'
}